import { getStatusConfig } from "@/lib/paymentStatusHelper";

interface Props {
  status: string | null | undefined;
  size?: "xs" | "sm";
  showIcon?: boolean;
}

/**
 * Reusable payment status badge.
 * Usage: <PaymentStatusBadge status={contract.payment_status} />
 */
export default function PaymentStatusBadge({ status, size = "xs", showIcon = true }: Props) {
  const cfg = getStatusConfig(status);

  const padding = size === "sm" ? "px-2.5 py-1" : "px-2 py-0.5";
  const text    = size === "sm" ? "text-xs"      : "text-[10px]";

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-semibold rounded-full whitespace-nowrap ${padding} ${text} ${cfg.badge}`}
    >
      {showIcon && (
        <span className="w-3 h-3 flex items-center justify-center flex-shrink-0">
          <i className={`${cfg.icon} text-[10px]`}></i>
        </span>
      )}
      {cfg.label}
    </span>
  );
}
